<div class="h-12 flex bg-white rounded-full text-gray-600 divide-x divide-gray-200/80 divide-solid shadow">
  <button (click)="firstPage.emit()"  [disabled]="currentPage === 1" class="text-base px-6 disabled:opacity-50">First
  </button>
  <button (click)="prevPage.emit(currentPage)" [disabled]="currentPage <= 1" class="text-base flex items-center px-6 disabled:opacity-50">
    <ion-icon name="arrow-back-outline" class="text-xl"></ion-icon>
  </button>
  <button (click)="nextPage.emit(currentPage)" [disabled]="currentPage >= totalPages" class="text-base flex items-center px-6 disabled:opacity-50">
    <ion-icon name="arrow-forward-outline" class="text-xl"></ion-icon>
  </button>
  <button (click)="lastPage.emit(totalPages)" [disabled]="currentPage === totalPages" class="text-base px-6 disabled:opacity-50">Last
  </button>
</div>
